/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplicationFormCommentCountsDto,
  CommentDto,
  CreateCommentDto,
  CursorPagedCommentDto,
  ProblemDetails,
} from '../models/index';
import {
    ApplicationFormCommentCountsDtoFromJSON,
    ApplicationFormCommentCountsDtoToJSON,
    CommentDtoFromJSON,
    CommentDtoToJSON,
    CreateCommentDtoFromJSON,
    CreateCommentDtoToJSON,
    CursorPagedCommentDtoFromJSON,
    CursorPagedCommentDtoToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface CreateCommentRequest {
    applicationFormId: string;
    formElementId: string;
    createCommentDto: CreateCommentDto;
}

export interface DeleteCommentRequest {
    id: string;
}

export interface GetCommentsByApplicationFormIdRequest {
    applicationFormId: string;
    formElementId?: string;
    cursorCreatedAt?: Date;
    limit?: number;
}

export interface GetGroupedCommentCountByApplicationFromIdRequest {
    applicationFormId: string;
}

export interface UpdateCommentRequest {
    id: string;
    commentDto: CommentDto;
}

/**
 * 
 */
export class CommentApi extends runtime.BaseAPI {

    /**
     * Create a new comment for a form element
     */
    async createCommentRaw(requestParameters: CreateCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommentDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling createComment().'
            );
        }

        if (requestParameters['formElementId'] == null) {
            throw new runtime.RequiredError(
                'formElementId',
                'Required parameter "formElementId" was null or undefined when calling createComment().'
            );
        }

        if (requestParameters['createCommentDto'] == null) {
            throw new runtime.RequiredError(
                'createCommentDto',
                'Required parameter "createCommentDto" was null or undefined when calling createComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/form-elements/{formElementId}/comments`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))).replace(`{${"formElementId"}}`, encodeURIComponent(String(requestParameters['formElementId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCommentDtoToJSON(requestParameters['createCommentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommentDtoFromJSON(jsonValue));
    }

    /**
     * Create a new comment for a form element
     */
    async createComment(requestParameters: CreateCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommentDto> {
        const response = await this.createCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a comment
     */
    async deleteCommentRaw(requestParameters: DeleteCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/comments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a comment
     */
    async deleteComment(requestParameters: DeleteCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCommentRaw(requestParameters, initOverrides);
    }

    /**
     * Get comments for specific application form
     */
    async getCommentsByApplicationFormIdRaw(requestParameters: GetCommentsByApplicationFormIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CursorPagedCommentDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling getCommentsByApplicationFormId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['formElementId'] != null) {
            queryParameters['formElementId'] = requestParameters['formElementId'];
        }

        if (requestParameters['cursorCreatedAt'] != null) {
            queryParameters['cursorCreatedAt'] = (requestParameters['cursorCreatedAt'] as any).toISOString();
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/comments`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CursorPagedCommentDtoFromJSON(jsonValue));
    }

    /**
     * Get comments for specific application form
     */
    async getCommentsByApplicationFormId(requestParameters: GetCommentsByApplicationFormIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CursorPagedCommentDto> {
        const response = await this.getCommentsByApplicationFormIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get comment counts grouped by form element for an application form
     */
    async getGroupedCommentCountByApplicationFromIdRaw(requestParameters: GetGroupedCommentCountByApplicationFromIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApplicationFormCommentCountsDto>> {
        if (requestParameters['applicationFormId'] == null) {
            throw new runtime.RequiredError(
                'applicationFormId',
                'Required parameter "applicationFormId" was null or undefined when calling getGroupedCommentCountByApplicationFromId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/application-forms/{applicationFormId}/comments/counts`.replace(`{${"applicationFormId"}}`, encodeURIComponent(String(requestParameters['applicationFormId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationFormCommentCountsDtoFromJSON(jsonValue));
    }

    /**
     * Get comment counts grouped by form element for an application form
     */
    async getGroupedCommentCountByApplicationFromId(requestParameters: GetGroupedCommentCountByApplicationFromIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApplicationFormCommentCountsDto> {
        const response = await this.getGroupedCommentCountByApplicationFromIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a comment
     */
    async updateCommentRaw(requestParameters: UpdateCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CommentDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateComment().'
            );
        }

        if (requestParameters['commentDto'] == null) {
            throw new runtime.RequiredError(
                'commentDto',
                'Required parameter "commentDto" was null or undefined when calling updateComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/comments/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CommentDtoToJSON(requestParameters['commentDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CommentDtoFromJSON(jsonValue));
    }

    /**
     * Update a comment
     */
    async updateComment(requestParameters: UpdateCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CommentDto> {
        const response = await this.updateCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
